export default __webpack_public_path__ + "5ffd514e574ae141cdab2cb15a84779f.jpg";